/*
 * @Author: cc
 * @LastEditTime: 2021-04-14 19:43:27
 */
/*
 * @Author: cc
 * @LastEditTime: 2021-04-08 16:09:40
 */
export interface VideoProps {
  type: string,
  vid: string,
  siteid: string,
  progressbar_enable: number,
  videoWatchAt: number,
  projectId: string,
  courseId: string,
  sectionId: string
}
const InitvideoStatus = {
  // 视频id
  vid: '',
  // ccUserId
  siteid: '',
  // 是否允许拖拽
  progressbar_enable: 1,
  // 观看位置
  videoWatchAt: 0,
  projectId: '',
  courseId: '',
  sectionId: ''
}
export const videoStatus = (state = InitvideoStatus, action: VideoProps) => {
  switch (action.type) {
    case "SET_VIDEO_STATUS":
      return {
        ...action,
      }
    default:
      return state
  }
}